import { IconSvg, IconSvgProps } from "./icon"

export default function CompassFill(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 21.167a8.357 8.357 0 1 0 0-16.714 8.357 8.357 0 0 0 0 16.714Z" />
      {/* The dial, filled, with the needle cut out */}
      <path
        d="M12 21.167a8.357 8.357 0 1 0 0-16.714 8.357 8.357 0 0 0 0 16.714ZM12.643 17.31l2.571-7.715L7.5 12.167l3.214 1.928 1.929 3.215Z"
        fill="currentColor"
        fillRule="evenodd"
        stroke="none"
      />
    </IconSvg>
  )
}
